import { Container } from 'main/container';

import { IconsPage } from 'js/icon-card/iconsPage';
import { SingleIconPage } from 'js/single-icon/singleIcon';
import { SubCategoryPage } from 'js/subcategory/subcategoryPage';

import subCategoryStore from 'js/stores/store';
import subCategoryActions from 'js/actions/actions';

// Vendo imports
import React from 'react';

// import 'normalize.css';

// import { createHistory, useBasename } from 'history'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  HashRouter
} from 'react-router-dom';
import { createBrowserHistory } from 'history';
const history = createBrowserHistory();

let previousHistoryLength = -1;
window.onpopstate = event => {
  if (previousHistoryLength === window.history.length) {
    const breadcrumbs = subCategoryStore.getState().breadcrumbs;
    const numberOfCrumbs = breadcrumbs.length;
    if (window.location.hash !== breadcrumbs[numberOfCrumbs - 1].link) {
      subCategoryActions.removeFromBreadCrumbs(breadcrumbs.length - 2);
    }
  }
  previousHistoryLength = window.history.length;
};

// window.onhashchange = () => {
//   const hash = decodeURI(window.location.hash);
//   const state = subCategoryStore.getState();
//   console.log(hash);

//   if (hash.indexOf('single') > -1) {
//     //item.keywords.join('%20')
//     const hashIcon = hash.split('?')[1];
//     let hashPack = '';
//     state.symbologyJson.packs.forEach(pack => {
//       pack.subpacks.forEach(subpack => {
//         subpack.icons.forEach(icon => {
//           if (icon.keywords.join(' ') === hashIcon) {
//             console.log('FOUND', icon);
//             hashPack = pack;
//             console.log(pack);
//           }
//         });
//       });
//     });
//   }
// };

export class App extends React.Component {
  render() {
    return (
      <HashRouter history={history}>
        <Container>
          <Switch>
            <Route exact path='/'>
              <IconsPage />
            </Route>
            <Route path='/single'>
              <SingleIconPage />
            </Route>
            <Route path='/subcat'>
              <SubCategoryPage />
              {/* <Route path='/subcat/:index' component={SubCategoryPage} /> */}
            </Route>
          </Switch>
        </Container>
      </HashRouter>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/app.js